const number = (value: number) => {
    return new Intl.NumberFormat('en-US').format(value)
}

export {
    number
}